import { message, Modal, notification as antNotification } from 'antd';

message.config({ maxCount: 1 });
antNotification.config({ duration: 7 });

const info = (content: string) => {
  message.info(content);
};

const success = (content: string, modal = false, onOk = () => {}) => {
  if (modal) {
    message.destroy();
    Modal.success({
      title: 'Success',
      content,
      onOk,
    });
  } else {
    message.success(content);
  }
};

interface GraphQLError {
  message?: string;
  errors?: {
    message: string;
  }[];
}

type Content = GraphQLError | string;

const isGraphQLError = (content: Content): content is GraphQLError =>
  typeof content === 'object' && !!(content?.message || content?.errors);

const error = (content: Content, modal = true) => {
  let errMessage: string | undefined;
  if (isGraphQLError(content)) {
    errMessage =
      content.errors?.map(({ message: m }) => m).join('<br>') ||
      content.message;
  } else {
    errMessage = content;
  }

  if (modal) {
    message.destroy();
    Modal.error({
      title: 'Oops, something went wrong...',
      content: errMessage,
    });
  } else {
    message.error(errMessage);
  }
};

const warning = (content: string) => {
  message.warning(content);
};

const loading = (content: string, duration: number = 0) => {
  message.loading(content, duration);
};

const destroy = () => {
  message.destroy();
};

type NotificationType = 'success' | 'info' | 'warning' | 'error';

const notification = (
  title: string,
  description: string,
  type: NotificationType = 'success',
) => {
  message.destroy();
  antNotification[type]({ title, description });
};

export { destroy, error, info, loading, notification, success, warning };
